export default __webpack_public_path__ + "static/media/beneficiary.e47989a7.svg";